export const repoData = [
  {
    user_id: '67269716',
    github_id: 'imvsr-0609',
    repo_id: '349312903',
    user_connection: 'True',
    repo_name: 'Meals-On-Wheels',
    contributors: null,
    total_commits: 26,
    commit_by_user: 23,
    created_date: '2021-03-19',
    last_commit: '2021-12-01',
    language_1: 'JavaScript',
    language_2: 'Jupyter Notebook',
    language_3: 'CSS',
    language_4: 'Python',
    language_5: 'HTML',
    language_6: null,
    language_7: null,
    language_8: null,
    language_9: null,
    language_10: null,
    language_1_per: 67.2749,
    language_2_per: 21.9537,
    language_3_per: 7.98039,
    language_4_per: 2.09462,
    language_5_per: 0.696379,
    language_6_per: 0,
    language_7_per: 0,
    language_8_per: 0,
    language_9_per: 0,
    language_10_per: 0,
    Processed: 'Y',
    commit_processed: 'N',
    stars: '0',
    description: 'Software engineering and project management project...',
    string_id: 'MDQ6VXNlcjY3MjY5NzE2',
    forks: 0,
    size: 5228,
    oneyearcommit: 0,
    lang: [
      {
        language: 'JavaScript',
        language_percentage: 67.2749,
        language_logo: {
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        }
      },
      {
        language: 'Jupyter Notebook',
        language_percentage: 21.9537,
        language_logo: {
          language_logo: null
        }
      },
      {
        language: 'CSS',
        language_percentage: 7.98039,
        language_logo: {
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        }
      },
      {
        language: 'Python',
        language_percentage: 2.09462,
        language_logo: {
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/python.svg'
        }
      },
      {
        language: 'HTML',
        language_percentage: 0.696379,
        language_logo: {
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/html.svg'
        }
      }
    ]
  },
  {
    avatar: {
      avatar_url: 'https://avatars.githubusercontent.com/u/67269716?v=4'
    }
  }
]

export const repoCommitData = {
  message: [
    {
      id: 70,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-04-14 12:58:01',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message:
        'Merge pull request #2 from Suvoo/deploy\n\nDeployed recommendation system',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 63,
      deletions: 19009,
      additions: 972,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjgyYWMwMDA3MDA5NzhmN2M3ZmVhMzI5Y2JkODZhZGUwZjUyOWFjYjQ=',
      language_name: [
        'CSS',
        'CSV',
        'HTML',
        'JSON',
        'JSX',
        'JavaScript',
        'Markdown',
        'Python',
        'TOML',
        'Text'
      ],
      files_changed:
        '.eslintcache,.gitignore,.streamlit/config.toml,Procfile,README.md,app.py,assets/Hyderabadi.jpg,assets/Masala-Dos.jpg,assets/cheese.jpg,assets/chilli-chicken.jpg,assets/dalfry.jpg,assets/foood.jpg,assets/goan.jpg,assets/indian-dishes.jpg,assets/naan.jpg,assets/paneer65.jpg,assets/rajma.jpg,input/food.csv,input/ratings.csv,package-lock.json,package.json,public/index.html,public/manifest.json,public/robots.txt,requirements.txt,runtime.txt,src/App.css,src/App.js,src/Pages/GalleryPage/GalleryPage.css,src/Pages/GalleryPage/GalleryPage.jsx,src/Pages/HomePage/HomePage.css,src/Pages/HomePage/HomePage.jsx,src/Pages/SignInPage/Sign-in-page.css,src/Pages/SignInPage/Sign-in-page.jsx,src/assets/image/gallery-background.jpg,src/assets/image/homepage-background.jpg,src/assets/image/mow-logo.jpg,src/assets/image/sign-in-background.jpg,src/components/Footer/Footer.css,src/components/Footer/Footer.jsx,src/components/Gallery/GalleryComponent.css,src/components/Gallery/GalleryComponent.jsx,src/components/HomePageBody/HomePageBody.css,src/components/HomePageBody/HomePageBody.jsx,src/components/HomePageTop/HomePageTop.css,src/components/HomePageTop/HomePageTop.jsx,src/components/Navbar/NavBar.css,src/components/Navbar/NavBar.jsx,src/components/Restaurant/Restaurant.css,src/components/Restaurant/Restaurant.jsx,src/components/SignInbottom/SignInBottom.css,src/components/SignInbottom/SignInBottom.jsx,src/components/SignIntop/SignInTop.css,src/components/SignIntop/SignInTop.jsx,src/components/customHooks/useLocation.jsx,src/components/customHooks/useRestaurant.jsx,src/components/gallery-card/GalleryCard.css,src/components/gallery-card/GalleryCard.jsx,src/context/UserProvider.jsx,src/firebase.js,src/index.css,src/index.js,src/reportWebVitals.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/82ac000700978f7c7fea329cbd86ade0f529acb4',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'CSV',
          language_logo: null
        },
        {
          name: 'HTML',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/html.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        },
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        },
        {
          name: 'Python',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/python.svg'
        },
        {
          name: 'TOML',
          language_logo: null
        },
        {
          name: 'Text',
          language_logo: null
        }
      ]
    },
    {
      id: 71,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-04-14 12:38:41',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'added deploy final',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 13,
      deletions: 7,
      additions: 32,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjM1NjQ3Y2IwNGQ4YTAyMTRmZTJlZmI0MzE2NWVmMzA0ZDY4YmJkZTQ=',
      language_name: ['Python', 'Text'],
      files_changed:
        'app.py,assets/Hyderabadi.jpg,assets/Masala-Dos.jpg,assets/cheese.jpg,assets/chilli-chicken.jpg,assets/dalfry.jpg,assets/foood.jpg,assets/goan.jpg,assets/indian-dishes.jpg,assets/naan.jpg,assets/paneer65.jpg,assets/rajma.jpg,requirements.txt',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/35647cb04d8a0214fe2efb43165ef304d68bbde4',
      languages: [
        {
          name: 'Python',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/python.svg'
        },
        {
          name: 'Text',
          language_logo: null
        }
      ]
    },
    {
      id: 72,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-04-14 06:52:52',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'deploy files',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 71,
      deletions: 19757,
      additions: 947,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjQ3YmFhOTY3OTIzMGIzOWYyMjhiMTgwOWRlZWYxNGZjZTIxYjVmYWI=',
      language_name: [
        'CSS',
        'CSV',
        'HTML',
        'JSON',
        'JSX',
        'JavaScript',
        'Markdown',
        'Python',
        'TOML',
        'Text'
      ],
      files_changed:
        '.eslintcache,.gitignore,.streamlit/config.toml,Procfile,README.md,app.py,cheese.jpg,indian-dishes.jpg,input/food.csv,input/ratings.csv,package-lock.json,package.json,public/index.html,public/manifest.json,public/robots.txt,requirements.txt,runtime.txt,src/App.css,src/App.js,src/Pages/CheckoutPage/CheckOut.css,src/Pages/CheckoutPage/CheckOut.jsx,src/Pages/GalleryPage/GalleryPage.css,src/Pages/GalleryPage/GalleryPage.jsx,src/Pages/HomePage/HomePage.css,src/Pages/HomePage/HomePage.jsx,src/Pages/SignInPage/Sign-in-page.css,src/Pages/SignInPage/Sign-in-page.jsx,src/assets/image/gallery-background.jpg,src/assets/image/homepage-background.jpg,src/assets/image/mow-logo.jpg,src/assets/image/order.png,src/assets/image/sign-in-background.jpg,src/components/CartComponent/Cart.css,src/components/CartComponent/Cart.jsx,src/components/CartItems/cartItems.css,src/components/CartItems/cartItems.jsx,src/components/CheckOutComponent/CheckOutComponent.css,src/components/CheckOutComponent/CheckOutComponent.jsx,src/components/Footer/Footer.css,src/components/Footer/Footer.jsx,src/components/Gallery/GalleryComponent.css,src/components/Gallery/GalleryComponent.jsx,src/components/HomePageBody/HomePageBody.css,src/components/HomePageBody/HomePageBody.jsx,src/components/HomePageBody/RestaurantData.js,src/components/HomePageTop/HomePageTop.css,src/components/HomePageTop/HomePageTop.jsx,src/components/Loader/Loader.css,src/components/Loader/Loader.jsx,src/components/MenuComponent/Menu.css,src/components/MenuComponent/Menu.jsx,src/components/MenuComponent/SingleMenu.jsx,src/components/MenuComponent/data.js,src/components/Navbar/NavBar.css,src/components/Navbar/NavBar.jsx,src/components/Restaurant/Restaurant.css,src/components/Restaurant/Restaurant.jsx,src/components/SignInbottom/SignInBottom.css,src/components/SignInbottom/SignInBottom.jsx,src/components/SignIntop/SignInTop.css,src/components/SignIntop/SignInTop.jsx,src/components/customHooks/useLocation.jsx,src/components/customHooks/useRestaurant.jsx,src/components/gallery-card/GalleryCard.css,src/components/gallery-card/GalleryCard.jsx,src/context/UserProvider.jsx,src/firebase.js,src/index.css,src/index.js,src/reportWebVitals.js,src/zomato.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/47baa9679230b39f228b1809deef14fce21b5fab',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'CSV',
          language_logo: null
        },
        {
          name: 'HTML',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/html.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        },
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        },
        {
          name: 'Python',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/python.svg'
        },
        {
          name: 'TOML',
          language_logo: null
        },
        {
          name: 'Text',
          language_logo: null
        }
      ]
    },
    {
      id: 73,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-10 19:23:58',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'updated',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 15,
      deletions: 28,
      additions: 323,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjFmMDczYTQxNmFkNjNhNDI4NmVhMmNkOTY4ODY1MjVjNTc5NzdiZGU=',
      language_name: ['CSS', 'JSX', 'JavaScript'],
      files_changed:
        '.eslintcache,src/App.js,src/Pages/CheckoutPage/CheckOut.jsx,src/Pages/GalleryPage/GalleryPage.css,src/Pages/HomePage/HomePage.jsx,src/components/CheckOutComponent/CheckOutComponent.css,src/components/CheckOutComponent/CheckOutComponent.jsx,src/components/HomePageBody/HomePageBody.jsx,src/components/HomePageBody/RestaurantData.js,src/components/MenuComponent/Menu.css,src/components/MenuComponent/Menu.jsx,src/components/MenuComponent/SingleMenu.jsx,src/components/MenuComponent/data.js,src/components/Navbar/NavBar.jsx,src/components/Restaurant/Restaurant.jsx',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/1f073a416ad63a4286ea2cd96886525c57977bde',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        }
      ]
    },
    {
      id: 74,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-03-27 09:35:12',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'checkout and payment completed',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 12,
      deletions: 9,
      additions: 278,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjM2OTdhYThlN2ZmZjI5YjIyM2M2YzBiM2QzZTE4OWViZTY2YzhhODU=',
      language_name: ['CSS', 'JSON', 'JSX'],
      files_changed:
        '.eslintcache,package-lock.json,package.json,src/Pages/CheckoutPage/CheckOut.css,src/Pages/CheckoutPage/CheckOut.jsx,src/assets/image/order.png,src/components/Navbar/NavBar.css,src/components/SignIntop/SignInTop.css,src/components/SignIntop/SignInTop.jsx,src/components/XheckOutComponent/CheckOutComponent.css,src/components/XheckOutComponent/CheckOutComponent.jsx,src/context/UserProvider.jsx',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/3697aa8e7fff29b223c6c0b3d3e189ebe66c8a85',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JSX',
          language_logo: null
        }
      ]
    },
    {
      id: 75,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-03-26 18:32:25',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'cart added',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 26,
      deletions: 150,
      additions: 401,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjdhMWYyN2ZhMWZjZDg3Y2FmOWNjMzE0NDY5OTgwMTJlNzAwOWEwZTM=',
      language_name: ['CSS', 'JSON', 'JSX', 'JavaScript'],
      files_changed:
        '.eslintcache,package-lock.json,package.json,public/manifest.json,src/App.js,src/Pages/CheckoutPage/CheckOut.css,src/Pages/CheckoutPage/CheckOut.jsx,src/Pages/GalleryPage/GalleryPage.jsx,src/Pages/HomePage/HomePage.jsx,src/components/CartComponent/Cart.css,src/components/CartComponent/Cart.jsx,src/components/CartItems/cartItems.css,src/components/CartItems/cartItems.jsx,src/components/Gallery/GalleryComponent.css,src/components/Gallery/GalleryComponent.jsx,src/components/HomePageTop/HomePageTop.jsx,src/components/Loader/Loader.css,src/components/Loader/Loader.jsx,src/components/Navbar/NavBar.css,src/components/Navbar/NavBar.jsx,src/components/SignIntop/SignInTop.jsx,src/components/customHooks/useLocation.jsx,src/context/UserProvider.jsx,src/firebase.js,src/index.js,src/zomato.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/7a1f27fa1fcd87caf9cc31446998012e7009a0e3',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        }
      ]
    },
    {
      id: 76,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-03-19 08:07:21',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'Update README.md',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 1,
      deletions: 1,
      additions: 1,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjM0ZTc4MjQ3MzkyNmI4ZTAzN2VlYzA5NWQ4M2E2MGNmZGZiMzU0NjY=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/34e782473926b8e037eec095d83a60cfdfb35466',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 77,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-03-19 08:01:26',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'Update README.md',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 1,
      deletions: 69,
      additions: 2,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOmY2MTMzZWFiZjlkMDk5NGM4OWE5NmUyODhiMjgzOTM1NjY3NGU2ZWE=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/f6133eabf9d0994c89a96e288b2839356674e6ea',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 78,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-03-19 07:58:48',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message:
        'Merge pull request #1 from imvsr-0609/Suvoo\n\ntesting master changes',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 1,
      deletions: 0,
      additions: 0,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjdiNThhODQzZDk0OTU1YTY1NTA1YWNjY2JhNzJmOGU4Nzg5NDAyMDc=',
      language_name: [''],
      files_changed: 'foood.jpg',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/7b58a843d94955a65505acccba72f8e878940207',
      languages: []
    },
    {
      id: 79,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-03-19 07:58:12',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'testing master changes',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 1,
      deletions: 0,
      additions: 0,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjI1MmY0N2E5OTMyODY0Njc5ZWIxYWE1NDE3YTE1YzMwMDA2ODhhN2U=',
      language_name: [''],
      files_changed: 'foood.jpg',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/252f47a9932864679eb1aa5417a15c3000688a7e',
      languages: []
    },
    {
      id: 80,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-03-19 05:38:07',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'commit 1',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 45,
      deletions: 84,
      additions: 2378,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjllNTI2NzRlYWNkYmZlMGNiNjNhNGUxOGU4NjhhMTQ5YTUxMmU3NjA=',
      language_name: ['CSS', 'HTML', 'JSON', 'JSX', 'JavaScript', 'SVG'],
      files_changed:
        '.eslintcache,package-lock.json,package.json,public/favicon.ico,public/index.html,public/logo192.png,public/logo512.png,src/App.css,src/App.js,src/App.test.js,src/Pages/GalleryPage/GalleryPage.css,src/Pages/GalleryPage/GalleryPage.jsx,src/Pages/HomePage/HomePage.css,src/Pages/HomePage/HomePage.jsx,src/Pages/SignInPage/Sign-in-page.css,src/Pages/SignInPage/Sign-in-page.jsx,src/assets/image/gallery-background.jpg,src/assets/image/homepage-background.jpg,src/assets/image/mow-logo.jpg,src/assets/image/sign-in-background.jpg,src/components/Footer/Footer.css,src/components/Footer/Footer.jsx,src/components/Gallery/GalleryComponent.css,src/components/Gallery/GalleryComponent.jsx,src/components/HomePageBody/HomePageBody.css,src/components/HomePageBody/HomePageBody.jsx,src/components/HomePageTop/HomePageTop.css,src/components/HomePageTop/HomePageTop.jsx,src/components/Navbar/NavBar.css,src/components/Navbar/NavBar.jsx,src/components/Restaurant/Restaurant.css,src/components/Restaurant/Restaurant.jsx,src/components/SignInbottom/SignInBottom.css,src/components/SignInbottom/SignInBottom.jsx,src/components/SignIntop/SignInTop.css,src/components/SignIntop/SignInTop.jsx,src/components/customHooks/useLocation.jsx,src/components/customHooks/useRestaurant.jsx,src/components/gallery-card/GalleryCard.css,src/components/gallery-card/GalleryCard.jsx,src/context/UserProvider.jsx,src/firebase.js,src/index.css,src/logo.svg,src/setupTests.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/9e52674eacdbfe0cb63a4e18e868a149a512e760',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'HTML',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/html.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        },
        {
          name: 'SVG',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/svg.svg'
        }
      ]
    },
    {
      id: 81,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-01-26 07:43:16',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'Initialize project using Create React App',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'Suvoo',
      changedFiles: 18,
      deletions: 0,
      additions: 16715,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjU3ZGU2Njc5ZTgyYzMxYjFiMmMyYTNmNDk2NjMwNGE2ZDEyMjk0OTg=',
      language_name: [
        'CSS',
        'HTML',
        'JSON',
        'JavaScript',
        'Markdown',
        'SVG',
        'Text'
      ],
      files_changed:
        '.gitignore,README.md,package-lock.json,package.json,public/favicon.ico,public/index.html,public/logo192.png,public/logo512.png,public/manifest.json,public/robots.txt,src/App.css,src/App.js,src/App.test.js,src/index.css,src/index.js,src/logo.svg,src/reportWebVitals.js,src/setupTests.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/57de6679e82c31b1b2c2a3f4966304a6d1229498',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'HTML',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/html.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        },
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        },
        {
          name: 'SVG',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/svg.svg'
        },
        {
          name: 'Text',
          language_logo: null
        }
      ]
    },
    {
      id: 82,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-06-07 16:27:10',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'Update README.md',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 1,
      additions: 2,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjcwMTc1MDM2NzJhNDdmZDkxY2E4N2UwYzI0MmQxMmNhZjdiMzZlZDY=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/7017503672a47fd91ca87e0c242d12caf7b36ed6',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 83,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-06-07 16:17:56',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'Update README.md',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 21,
      additions: 0,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOmM5ZDI4ZjQ2Zjc3NzcxNGRmM2Y2N2VhMGJmZDYzYjg5ZGM1NDEwNWI=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/c9d28f46f777714df3f67ea0bfd63b89dc54105b',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 84,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-06-07 16:16:24',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'Update README.md',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 2,
      additions: 98,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOmU1YzkyZjU0ZTU2OTRiZjc0MDlmODE2OWYxNDI1MDlmNDJhMTBlNzg=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/e5c92f54e5694bf7409f8169f142509f42a10e78',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 85,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-05-24 12:27:41',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message:
        "Merge branch 'master' of https://github.com/imvsr-0609/Meals-On-Wheels into master",
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 0,
      additions: 1656,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjJiMjk1ZjdiYTAxZjU2MTBkNDg0YzhmZGRjMjlmMjlkZGY5NjRiMjQ=',
      language_name: ['Jupyter Notebook'],
      files_changed: 'ML Recommendation/fooddemo.ipynb',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/2b295f7ba01f5610d484c8fddc29f29ddf964b24',
      languages: [
        {
          name: 'Jupyter Notebook',
          language_logo: null
        }
      ]
    },
    {
      id: 86,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-05-24 12:27:20',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: ' firebase rules changed',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 7,
      deletions: 16,
      additions: 7,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjNkZWRkMWExY2JjNTNiNmZkYmM3OWU2MzVlNWNjM2NmMzNkOTNjYWM=',
      language_name: ['JSX', 'JavaScript'],
      files_changed:
        '.eslintcache,src/Pages/AboutPage/AboutPage.jsx,src/Pages/CheckoutPage/CheckOut.jsx,src/components/MenuComponent/Menu.jsx,src/context/UserProvider.jsx,src/index.js,src/zomato.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/3dedd1a1cbc53b6fdbc79e635e5cc3cf33d93cac',
      languages: [
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        }
      ]
    },
    {
      id: 87,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-05-05 10:04:40',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'added ML notebook',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 0,
      additions: 1656,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOmM0OTllMmE5N2IzMDkxNDgzYTViZjFlNmRkODkxMTAyMmJiMjlkMzE=',
      language_name: ['Jupyter Notebook'],
      files_changed: 'ML Recommendation/fooddemo.ipynb',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/c499e2a97b3091483a5bf1e6dd8911022bb29d31',
      languages: [
        {
          name: 'Jupyter Notebook',
          language_logo: null
        }
      ]
    },
    {
      id: 88,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-30 17:19:22',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'input working now',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 3,
      deletions: 4,
      additions: 9,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOmU4MGEzNGZkYTcwOGVmZDBjNTVkZmFkYWM0MTJkYmJjMGQ0ZWQ0Mjk=',
      language_name: ['JSX'],
      files_changed:
        '.eslintcache,src/Pages/AboutPage/AboutPage.jsx,src/components/HomePageBody/HomePageBody.jsx',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/e80a34fda708efd0c55dfadac412dbbc0d4ed429',
      languages: [
        {
          name: 'JSX',
          language_logo: null
        }
      ]
    },
    {
      id: 89,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-30 06:26:48',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'few updates',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 3,
      deletions: 3,
      additions: 13,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjBlNTZjZTI3Mjg4NGNmYTAxYjM2N2EwMzZhZTUxZGUzZGFlY2UwODU=',
      language_name: ['CSS', 'JSX'],
      files_changed:
        '.eslintcache,src/components/MenuComponent/Menu.css,src/components/MenuComponent/SingleMenu.jsx',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/0e56ce272884cfa01b367a036ae51de3daece085',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSX',
          language_logo: null
        }
      ]
    },
    {
      id: 90,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-29 18:00:17',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'few changes',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 2,
      deletions: 4,
      additions: 7,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjcyZGE2YWRkZDdmZDYxOTZlNDdjNzRmYjE5NDQxNjYwODAyZTEzYmU=',
      language_name: ['JSX'],
      files_changed: '.eslintcache,src/components/HomePageTop/HomePageTop.jsx',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/72da6addd7fd6196e47c74fb19441660802e13be',
      languages: [
        {
          name: 'JSX',
          language_logo: null
        }
      ]
    },
    {
      id: 91,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-29 16:03:48',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message:
        "Merge branch 'master' of https://github.com/imvsr-0609/Meals-On-Wheels into master",
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 0,
      additions: 2,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjdhOGVjYTQ2OTA4NjgxNTk3YjRkM2YzYjhiZGQyZTg1MzA5ZDdkMzE=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/7a8eca46908681597b4d3f3b8bdd2e85309d7d31',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 92,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-29 16:03:10',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'few changes',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 5,
      deletions: 6,
      additions: 9,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjY4Njk4ZjEzZGMwMzE4NTU0YzMwNzllYmEwN2JiNzg2ZmFkOTI1MjQ=',
      language_name: ['CSS', 'JSX'],
      files_changed:
        '.eslintcache,src/components/Footer/Footer.jsx,src/components/HomePageTop/HomePageTop.jsx,src/components/Navbar/NavBar.jsx,src/index.css',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/68698f13dc0318554c3079eba07bb786fad92524',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSX',
          language_logo: null
        }
      ]
    },
    {
      id: 93,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-29 12:31:30',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'Update README.md',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 0,
      additions: 2,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjU5YzBlMjhkOTRjMGY3NmQ4Nzk5Y2QyZjM5OWJjNDA2NzQ1Yzk0YWQ=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/59c0e28d94c0f76d8799cd2f399bc406745c94ad',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 94,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-29 12:28:54',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'finished',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 4,
      deletions: 7,
      additions: 5,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjdiOGUzMmNhZGJjNzU0ODJlM2I0YzgzMjJhMGY4NmE4NTBlOTYxYjI=',
      language_name: ['JSX'],
      files_changed:
        '.eslintcache,src/Pages/HomePage/HomePage.jsx,src/components/HomePageBody/HomePageBody.jsx,src/components/Navbar/NavBar.jsx',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/7b8e32cadbc75482e3b4c8322a0f86a850e961b2',
      languages: [
        {
          name: 'JSX',
          language_logo: null
        }
      ]
    },
    {
      id: 95,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-29 11:49:02',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'finished',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 25,
      deletions: 759,
      additions: 4739,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjU2NDYwZjdjNjU3MWE5YWU0OGNlZmJlNjNhZmYzOWM0MDY3ZWVkMWU=',
      language_name: ['CSS', 'JSX', 'JavaScript'],
      files_changed:
        '.eslintcache,src/Pages/AboutPage/aboutData.js,src/Pages/CheckoutPage/CheckOut.jsx,src/Pages/GalleryPage/GalleryPage.jsx,src/Pages/HomePage/HomePage.jsx,src/Pages/SignInPage/Sign-in-page.jsx,src/components/CartItems/cartItems.jsx,src/components/Footer/Footer.jsx,src/components/Gallery/GalleryComponent.jsx,src/components/HomePageBody/HomePageBody.jsx,src/components/HomePageBody/RestaurantData.js,src/components/HomePageTop/HomePageTop.jsx,src/components/Loader/Loader.jsx,src/components/MenuComponent/Menu.jsx,src/components/MenuComponent/data.js,src/components/Restaurant/Restaurant.css,src/components/Restaurant/Restaurant.jsx,src/components/SignInbottom/SignInBottom.jsx,src/components/SignIntop/SignInTop.jsx,src/components/customHooks/useLocation.jsx,src/components/customHooks/useRestaurant.jsx,src/components/gallery-card/GalleryCard.jsx,src/context/UserProvider.jsx,src/firebase.js,src/index.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/56460f7c6571a9ae48cefbe63aff39c4067eed1e',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        }
      ]
    },
    {
      id: 96,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-20 09:19:18',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'meals on wheels',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 28,
      deletions: 368,
      additions: 21491,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjE5NTg4ZmNmYTQ0NmE5MTdlMDI1ZTQ4OWNkNzczZTZjMjI5M2NjYTU=',
      language_name: ['CSS', 'JSON', 'JSX', 'JavaScript'],
      files_changed:
        '.eslintcache,package-lock.json,package.json,src/App.js,src/Pages/AboutPage/AboutPage.css,src/Pages/AboutPage/AboutPage.jsx,src/Pages/AboutPage/aboutData.js,src/Pages/CheckoutPage/CheckOut.css,src/Pages/CheckoutPage/CheckOut.jsx,src/assets/image/about-background.jpg,src/components/CartComponent/Cart.css,src/components/CartComponent/Cart.jsx,src/components/CartItems/cartItems.css,src/components/CartItems/cartItems.jsx,src/components/CheckOutComponent/CheckOutComponent.css,src/components/CheckOutComponent/CheckOutComponent.jsx,src/components/Gallery/GalleryComponent.jsx,src/components/HomePageBody/HomePageBody.css,src/components/HomePageTop/HomePageTop.css,src/components/MenuComponent/Menu.css,src/components/MenuComponent/Menu.jsx,src/components/MenuComponent/SingleMenu.jsx,src/components/Navbar/NavBar.css,src/components/Navbar/NavBar.jsx,src/components/Restaurant/Restaurant.css,src/components/customHooks/useLocation.jsx,src/context/UserProvider.jsx,src/firebase.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/19588fcfa446a917e025e489cd773e6c2293cca5',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        }
      ]
    },
    {
      id: 97,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-04-14 13:14:22',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'Update README.md',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 0,
      additions: 2,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjE0ZDMyZmEwMWFlZTQ0MzYzZGFiMjQ3MjYyZDYwYjBiNzQ3MjBjYWY=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/14d32fa01aee44363dab247262d60b0b74720caf',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 98,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-04-14 13:10:48',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'added ML part',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 17,
      deletions: 0,
      additions: 954,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOmFiYmFjZjM5YzI2YzBkMTlhNDRkMjQ0YWRmMjAwYzA1MjhkZjgwYzA=',
      language_name: ['CSV', 'Python', 'Text'],
      files_changed:
        'ML Recommendation/Procfile,ML Recommendation/app.py,ML Recommendation/assets/Hyderabadi.jpg,ML Recommendation/assets/Masala-Dos.jpg,ML Recommendation/assets/cheese.jpg,ML Recommendation/assets/chilli-chicken.jpg,ML Recommendation/assets/dalfry.jpg,ML Recommendation/assets/foood.jpg,ML Recommendation/assets/goan.jpg,ML Recommendation/assets/indian-dishes.jpg,ML Recommendation/assets/naan.jpg,ML Recommendation/assets/paneer65.jpg,ML Recommendation/assets/rajma.jpg,ML Recommendation/input/food.csv,ML Recommendation/input/ratings.csv,ML Recommendation/requirements.txt,ML Recommendation/runtime.txt',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/abbacf39c26c0d19a44d244adf200c0528df80c0',
      languages: [
        {
          name: 'CSV',
          language_logo: null
        },
        {
          name: 'Python',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/python.svg'
        },
        {
          name: 'Text',
          language_logo: null
        }
      ]
    },
    {
      id: 99,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-04-10 19:23:58',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'updated',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 15,
      deletions: 28,
      additions: 323,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjFmMDczYTQxNmFkNjNhNDI4NmVhMmNkOTY4ODY1MjVjNTc5NzdiZGU=',
      language_name: ['CSS', 'JSX', 'JavaScript'],
      files_changed:
        '.eslintcache,src/App.js,src/Pages/CheckoutPage/CheckOut.jsx,src/Pages/GalleryPage/GalleryPage.css,src/Pages/HomePage/HomePage.jsx,src/components/CheckOutComponent/CheckOutComponent.css,src/components/CheckOutComponent/CheckOutComponent.jsx,src/components/HomePageBody/HomePageBody.jsx,src/components/HomePageBody/RestaurantData.js,src/components/MenuComponent/Menu.css,src/components/MenuComponent/Menu.jsx,src/components/MenuComponent/SingleMenu.jsx,src/components/MenuComponent/data.js,src/components/Navbar/NavBar.jsx,src/components/Restaurant/Restaurant.jsx',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/1f073a416ad63a4286ea2cd96886525c57977bde',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        }
      ]
    },
    {
      id: 100,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-03-27 09:35:12',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'checkout and payment completed',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 12,
      deletions: 9,
      additions: 278,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjM2OTdhYThlN2ZmZjI5YjIyM2M2YzBiM2QzZTE4OWViZTY2YzhhODU=',
      language_name: ['CSS', 'JSON', 'JSX'],
      files_changed:
        '.eslintcache,package-lock.json,package.json,src/Pages/CheckoutPage/CheckOut.css,src/Pages/CheckoutPage/CheckOut.jsx,src/assets/image/order.png,src/components/Navbar/NavBar.css,src/components/SignIntop/SignInTop.css,src/components/SignIntop/SignInTop.jsx,src/components/XheckOutComponent/CheckOutComponent.css,src/components/XheckOutComponent/CheckOutComponent.jsx,src/context/UserProvider.jsx',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/3697aa8e7fff29b223c6c0b3d3e189ebe66c8a85',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JSX',
          language_logo: null
        }
      ]
    },
    {
      id: 101,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-03-26 18:32:25',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'cart added',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 26,
      deletions: 150,
      additions: 401,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjdhMWYyN2ZhMWZjZDg3Y2FmOWNjMzE0NDY5OTgwMTJlNzAwOWEwZTM=',
      language_name: ['CSS', 'JSON', 'JSX', 'JavaScript'],
      files_changed:
        '.eslintcache,package-lock.json,package.json,public/manifest.json,src/App.js,src/Pages/CheckoutPage/CheckOut.css,src/Pages/CheckoutPage/CheckOut.jsx,src/Pages/GalleryPage/GalleryPage.jsx,src/Pages/HomePage/HomePage.jsx,src/components/CartComponent/Cart.css,src/components/CartComponent/Cart.jsx,src/components/CartItems/cartItems.css,src/components/CartItems/cartItems.jsx,src/components/Gallery/GalleryComponent.css,src/components/Gallery/GalleryComponent.jsx,src/components/HomePageTop/HomePageTop.jsx,src/components/Loader/Loader.css,src/components/Loader/Loader.jsx,src/components/Navbar/NavBar.css,src/components/Navbar/NavBar.jsx,src/components/SignIntop/SignInTop.jsx,src/components/customHooks/useLocation.jsx,src/context/UserProvider.jsx,src/firebase.js,src/index.js,src/zomato.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/7a1f27fa1fcd87caf9cc31446998012e7009a0e3',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        }
      ]
    },
    {
      id: 102,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-03-19 08:07:21',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'Update README.md',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 1,
      additions: 1,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjM0ZTc4MjQ3MzkyNmI4ZTAzN2VlYzA5NWQ4M2E2MGNmZGZiMzU0NjY=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/34e782473926b8e037eec095d83a60cfdfb35466',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 103,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-03-19 08:01:26',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'Update README.md',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 69,
      additions: 2,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOmY2MTMzZWFiZjlkMDk5NGM4OWE5NmUyODhiMjgzOTM1NjY3NGU2ZWE=',
      language_name: ['Markdown'],
      files_changed: 'README.md',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/f6133eabf9d0994c89a96e288b2839356674e6ea',
      languages: [
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        }
      ]
    },
    {
      id: 104,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-03-19 07:58:48',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message:
        'Merge pull request #1 from imvsr-0609/Suvoo\n\ntesting master changes',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 0,
      additions: 0,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjdiNThhODQzZDk0OTU1YTY1NTA1YWNjY2JhNzJmOGU4Nzg5NDAyMDc=',
      language_name: [''],
      files_changed: 'foood.jpg',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/7b58a843d94955a65505acccba72f8e878940207',
      languages: []
    },
    {
      id: 105,
      user_id: 'MDQ6VXNlcjUyNzk2MjU4',
      github_id: 'Suvoo',
      user_name: 'Suvodeep Sinha',
      commit_date: '2021-03-19 07:58:12',
      profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
      message: 'testing master changes',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 1,
      deletions: 0,
      additions: 0,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjI1MmY0N2E5OTMyODY0Njc5ZWIxYWE1NDE3YTE1YzMwMDA2ODhhN2U=',
      language_name: [''],
      files_changed: 'foood.jpg',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/252f47a9932864679eb1aa5417a15c3000688a7e',
      languages: []
    },
    {
      id: 106,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-03-19 05:38:07',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'commit 1',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 45,
      deletions: 84,
      additions: 2378,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjllNTI2NzRlYWNkYmZlMGNiNjNhNGUxOGU4NjhhMTQ5YTUxMmU3NjA=',
      language_name: ['CSS', 'HTML', 'JSON', 'JSX', 'JavaScript', 'SVG'],
      files_changed:
        '.eslintcache,package-lock.json,package.json,public/favicon.ico,public/index.html,public/logo192.png,public/logo512.png,src/App.css,src/App.js,src/App.test.js,src/Pages/GalleryPage/GalleryPage.css,src/Pages/GalleryPage/GalleryPage.jsx,src/Pages/HomePage/HomePage.css,src/Pages/HomePage/HomePage.jsx,src/Pages/SignInPage/Sign-in-page.css,src/Pages/SignInPage/Sign-in-page.jsx,src/assets/image/gallery-background.jpg,src/assets/image/homepage-background.jpg,src/assets/image/mow-logo.jpg,src/assets/image/sign-in-background.jpg,src/components/Footer/Footer.css,src/components/Footer/Footer.jsx,src/components/Gallery/GalleryComponent.css,src/components/Gallery/GalleryComponent.jsx,src/components/HomePageBody/HomePageBody.css,src/components/HomePageBody/HomePageBody.jsx,src/components/HomePageTop/HomePageTop.css,src/components/HomePageTop/HomePageTop.jsx,src/components/Navbar/NavBar.css,src/components/Navbar/NavBar.jsx,src/components/Restaurant/Restaurant.css,src/components/Restaurant/Restaurant.jsx,src/components/SignInbottom/SignInBottom.css,src/components/SignInbottom/SignInBottom.jsx,src/components/SignIntop/SignInTop.css,src/components/SignIntop/SignInTop.jsx,src/components/customHooks/useLocation.jsx,src/components/customHooks/useRestaurant.jsx,src/components/gallery-card/GalleryCard.css,src/components/gallery-card/GalleryCard.jsx,src/context/UserProvider.jsx,src/firebase.js,src/index.css,src/logo.svg,src/setupTests.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/9e52674eacdbfe0cb63a4e18e868a149a512e760',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'HTML',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/html.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JSX',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        },
        {
          name: 'SVG',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/svg.svg'
        }
      ]
    },
    {
      id: 107,
      user_id: 'MDQ6VXNlcjY3MjY5NzE2',
      github_id: 'imvsr-0609',
      user_name: 'Vedant Singh',
      commit_date: '2021-01-26 07:43:16',
      profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
      message: 'Initialize project using Create React App',
      repo_name: 'Meals-On-Wheels',
      branch_name: 'master',
      changedFiles: 18,
      deletions: 0,
      additions: 16715,
      repo_owner: 'imvsr-0609',
      commit_id:
        'MDY6Q29tbWl0MzQ5MzEyOTAzOjU3ZGU2Njc5ZTgyYzMxYjFiMmMyYTNmNDk2NjMwNGE2ZDEyMjk0OTg=',
      language_name: [
        'CSS',
        'HTML',
        'JSON',
        'JavaScript',
        'Markdown',
        'SVG',
        'Text'
      ],
      files_changed:
        '.gitignore,README.md,package-lock.json,package.json,public/favicon.ico,public/index.html,public/logo192.png,public/logo512.png,public/manifest.json,public/robots.txt,src/App.css,src/App.js,src/App.test.js,src/index.css,src/index.js,src/logo.svg,src/reportWebVitals.js,src/setupTests.js',
      commit_url:
        'https://github.com/imvsr-0609/Meals-On-Wheels/commit/57de6679e82c31b1b2c2a3f4966304a6d1229498',
      languages: [
        {
          name: 'CSS',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/css.svg'
        },
        {
          name: 'HTML',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/html.svg'
        },
        {
          name: 'JSON',
          language_logo: null
        },
        {
          name: 'JavaScript',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/javascript.svg'
        },
        {
          name: 'Markdown',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/markdown.svg'
        },
        {
          name: 'SVG',
          language_logo:
            'https://languagelogo.s3.ap-south-1.amazonaws.com/svg.svg'
        },
        {
          name: 'Text',
          language_logo: null
        }
      ]
    }
  ]
}

export const parsedCommitData = [
  {
    id: 70,
    user_id: 'MDQ6VXNlcjUyNzk2MjU4',
    github_id: 'Suvoo',
    user_name: 'Suvodeep Sinha',
    commit_date: '2021-04-14 12:58:01',
    profile_pic: 'https://avatars.githubusercontent.com/u/52796258?v=4',
    message:
      'Merge pull request #2 from Suvoo/deploy\n\nDeployed recommendation system',
    repo_name: 'Meals-On-Wheels',
    branch_name: 'Suvoo',
    changedFiles: 175,
    deletions: 38935,
    additions: 4667,
    repo_owner: 'imvsr-0609',
    commit_id:
      'MDY6Q29tbWl0MzQ5MzEyOTAzOjgyYWMwMDA3MDA5NzhmN2M3ZmVhMzI5Y2JkODZhZGUwZjUyOWFjYjQ=',
    language_name: null,
    files_changed: null,
    commit_url:
      'https://github.com/imvsr-0609/Meals-On-Wheels/commit/82ac000700978f7c7fea329cbd86ade0f529acb4'
  },
  {
    id: 73,
    user_id: 'MDQ6VXNlcjY3MjY5NzE2',
    github_id: 'imvsr-0609',
    user_name: 'Vedant Singh',
    commit_date: '2021-04-10 19:23:58',
    profile_pic: 'https://avatars.githubusercontent.com/u/67269716?v=4',
    message: 'updated',
    repo_name: 'Meals-On-Wheels',
    branch_name: 'Suvoo',
    changedFiles: 314,
    deletions: 1711,
    additions: 68132,
    repo_owner: 'imvsr-0609',
    commit_id:
      'MDY6Q29tbWl0MzQ5MzEyOTAzOjFmMDczYTQxNmFkNjNhNDI4NmVhMmNkOTY4ODY1MjVjNTc5NzdiZGU=',
    language_name: null,
    files_changed: null,
    commit_url:
      'https://github.com/imvsr-0609/Meals-On-Wheels/commit/1f073a416ad63a4286ea2cd96886525c57977bde'
  }
]
